export enum FertigerComplaintResponseType {
	Unknown = 0,
	Declined = 1,
	AcceptedErsatzlieferung = 2,
	RequestedNacharbeit = 3,
	Discount = 4,
}
